import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  solid,
  regular,
  brands,
} from "@fortawesome/fontawesome-svg-core/import.macro";
import FooterMenu from "./FooterMenu";
import HeaderMenu from "./HeaderMenu";
import { Link } from "react-router-dom";

const MainLayout = (props) => {
  return (
    <div>
      {/* HEADER */}
      <div className="hidden sm:flex h-7 mt-2 justify-between max-w-7xl mx-auto md:px-2 border-b border-slate-900/10">
        <div className="flex gap-3">
          <p className="text-[#6A983C] text-sm">Chat With Us</p>
          <p className="text-sm">+62 822 1111 1111</p>
          <p className="text-sm">farix@raharja.info</p>
        </div>
        <div className="flex gap-3">
          <p className="text-[#6A983C] text-sm">Blog</p>
          <p className="text-[#6A983C] text-sm">About Us</p>
          <p className="text-[#6A983C] text-sm">Careers</p>
        </div>
      </div>

      <div className="sticky z-40 top-0 w-full px-4 backdrop-blur-sm bg-white/50 border-b border-slate-900/10">
        <div className="h-16 sm:h-24 flex items-center max-w-7xl mx-auto">
          <div className="hidden sm:block">
            <Link to="/">
              <h1 className="text-2xl font-extrabold">LeumangShop</h1>
            </Link>
          </div>
          <div className="block sm:hidden">
            <Link to="/">
              <h1 className="text-2xl">&#127793;</h1>
            </Link>
          </div>
          <div className="flex gap-4 w-full  justify-center">
            <input
              className="placeholder:text-slate-400 block bg-[#F9F9F9] w-4/5 sm:w-2/4 border border-slate-300 rounded-2xl py-1 pl-4 shadow-sm focus:outline-none focus:border-[#6A983C] focus:ring-sky-500 focus:ring-1 sm:text-sm"
              placeholder="Search Products, Categories..."
              type="text"
              name="search"
            />
            <div className="hidden sm:block -ml-12 mt-1">
              <FontAwesomeIcon icon={solid("search")} size="sm" />
            </div>
          </div>
          <div className="flex gap-5 m-auto">
            <FontAwesomeIcon icon={solid("user")} size="lg" />
            <span className="fa-layers fa-fw">
              <FontAwesomeIcon icon={solid("basket-shopping")} size="lg" />
              <span className="fa-layers-counter h-14 w-14 rounded-full absolute right-2 top-3">
                <h1 className="font-bold text-[40px]">4</h1>
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="hidden sm:block w-full bg-[#F9F9F9]">
        <div className="px-4 max-w-7xl h-8 mx-auto  flex justify-around">
          <HeaderMenu title="Bakery" />
          <HeaderMenu title="Fruit and Vegetables" />
          <HeaderMenu title="Meat and Fish" />
          <HeaderMenu title="Drinks" />
          <HeaderMenu title="Kitchen" />
          <HeaderMenu title="Special Nutrition" />
          <HeaderMenu title="Baby" />
          <HeaderMenu title="Pharmacy" />
        </div>
      </div>
      {/* <div className="bg-slate-900 "></div> */}
      {props.children}
      {/* FOOTER */}
      <div className="max-w-7xl mx-auto h-full grid grid-cols-2 gap-2 sm:h-52 sm:flex sm:justify-center sm:items-start bg-white pt-5 ">
        <FooterMenu
          title="Get in Touch"
          item={["About us", "Careers", "Press Releases", "Blog"]}
        />
        <FooterMenu
          title="Connections"
          item={["Facebook", "Twitter", "Instagram", "Youtube", "LinkdIn"]}
        />
        <FooterMenu
          title="Earnings"
          item={[
            "Become an Affiliate",
            "Advertise Your Product",
            "Sell On Market",
          ]}
        />
        <FooterMenu
          title="Account"
          item={[
            "Your Account",
            "Returns Centre",
            "100% Purchase Protection",
            "Chat With Us",
            "Help",
          ]}
        />
      </div>

      {/* <div className="max-w-7xl mx-auto h-full grid grid-cols-2 sm:h-52 sm:flex sm:justify-center sm:items-center bg-white ">
        <div className="mx-auto pb-5 ">
          <h1 className="text-xl font-bold">Get in Touch</h1>
          <p className="text-[#6A983C]">About Us</p>
          <p className="text-[#6A983C]">Careers</p>
          <p className="text-[#6A983C]">Press Releases</p>
          <p className="text-[#6A983C]">Blog</p>
        </div>
        <div className="mx-auto pb-5 ">
          <h1 className="text-xl font-bold">Connections</h1>
          <p className="text-[#6A983C]">Facebook</p>
          <p className="text-[#6A983C]">Twitter</p>
          <p className="text-[#6A983C]">Instagram</p>
          <p className="text-[#6A983C]">LinkedIn</p>
        </div>
        <div className="mx-auto pb-5 ">
          <h1 className="text-xl font-bold">Get in Touch</h1>
          <p className="text-[#6A983C]">About Us</p>
          <p className="text-[#6A983C]">Careers</p>
          <p className="text-[#6A983C]">Press Releases</p>
          <p className="text-[#6A983C]">Blog</p>
        </div>
        <div className="mx-auto pb-5 ">
          <h1 className="text-xl font-bold">Connections</h1>
          <p className="text-[#6A983C]">Facebook</p>
          <p className="text-[#6A983C]">Twitter</p>
          <p className="text-[#6A983C]">Instagram</p>
          <p className="text-[#6A983C]">LinkedIn</p>
        </div>
      </div> */}

      <div className="bg-[#F9F9F9] h-8 sticky bottom-0 flex items-center justify-center border-t border-slate-900/10 backdrop-blur-sm bg-white/50">
        <p className="font-base">
          Made with <span>&#128154; by</span>
          <a href="https://github.com/exwn" className="font-semibold">
            {" "}
            Farix Ikhwanul
          </a>
        </p>
      </div>
    </div>
  );
};

export default MainLayout;
